import React from "react";
import Call from "../../../hocs/call";
import {connect} from "react-redux";
import ArtefactList from "../../../components/artefact-list";
import {
  deleteMsdsMsd,
  deleteMsdsSelectedMsds,
  hideMsdsMsdParentsAndChildren,
  readMsdsListMsds,
  readMsdsMsdParentsAndChildren,
  showMsdsMsdClone,
  showMsdsMsdDetail,
  showMsdsMsdDownload,
  showMsdsMsdExport
} from "./actions";

const mapStateToProps = state => ({
  msds: state.scenes.metaManager.msds.msds,
  parentsAndChildren: state.scenes.metaManager.msds.parentsAndChildren
});

const mapDispatchToProps = dispatch => ({
  fetchMsds: () => dispatch(readMsdsListMsds()),
  onMsdShow: msdTriplet => dispatch(showMsdsMsdDetail(msdTriplet)),
  onDelete: msdTriplet => dispatch(deleteMsdsMsd(msdTriplet)),
  onSelectedMsdsDelete: msdTriplets => dispatch(deleteMsdsSelectedMsds(msdTriplets)),
  onDownloadShow: (msdTriplets, lang) => dispatch(showMsdsMsdDownload(msdTriplets, lang)),
  fetchParentsAndChildren: (artefactType, artefactTriplet) =>
    dispatch(readMsdsMsdParentsAndChildren(artefactType, artefactTriplet)),
  onParentsAndChildrenHide: () => dispatch(hideMsdsMsdParentsAndChildren()),
  onCloneShow: artefactTriplet => dispatch(showMsdsMsdClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showMsdsMsdExport(sourceTriplet)),
});

const MsdsList = ({
                    msds,
                    fetchMsds,
                    onMsdShow,
                    onDelete,
                    onSelectedMsdsDelete,
                    onDownloadShow,
                    parentsAndChildren,
                    fetchParentsAndChildren,
                    onParentsAndChildrenHide,
                    onCloneShow,
                    onExportShow
                  }) =>
  <Call cb={fetchMsds} disabled={msds !== null}>
    <ArtefactList
      artefacts={msds}
      onDetailShow={onMsdShow}
      onDownloadShow={onDownloadShow}
      onDelete={onDelete}
      onSelectedItemDelete={onSelectedMsdsDelete}
      parentsAndChildren={parentsAndChildren}
      fetchParentsAndChildren={triplet => fetchParentsAndChildren("metadatastructure", triplet)}
      onParentsAndChildrenHide={onParentsAndChildrenHide}
      showImportButton
      onCloneShow={onCloneShow}
      onExportShow={onExportShow}
    />
  </Call>;

export default connect(mapStateToProps, mapDispatchToProps)(MsdsList);



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/msds/List.jsx